
<!-- Content Header (Page header) -->
<section class="content-header">
    <div class="content-header">
       <div class="container-fluid">
         <div class="row mb-2">
           <div class="col-sm-6">
               <h3>Vehicle Details Overview</h3>
           </div>
           <div class="col-sm-6">
             <ol class="breadcrumb float-sm-right">
               <li class="breadcrumb-item"><a routerLink="/"><i class="nav-icon fas fa-tachometer-alt"></i>&nbsp;Dashboard</a></li>
               <li class="breadcrumb-item"><a routerLink="/vehicles" *ngIf="userPermissions.includes('view-vhcl-list')"><i class="fa fa-list-ul"></i>&nbsp;Vehicles</a></li>
               <li class="breadcrumb-item active">Vehicle Details Overview</li>
             </ol>
           </div><!-- /.col -->
         </div><!-- /.row -->
       </div><!-- /.container-fluid -->
   </div>
</section>
<!-- /.content-header -->
<!--Loading Spinner-->
<div *ngIf="isLoading">
    <app-spinner></app-spinner>
</div>
<section class="content">
   <div class="container-fluid">
        <div class="card">
            <div class="card-header">
                <h3 class="card-title">Viewing Details for {{vehicle?.data?.make}} {{vehicle?.data?.model}} - {{vehicle.data.chassis_no}}</h3>
                <!--Error Message-->
                <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
                    {{errorMessage}}
                </div>
                <!--Success Message-->
                <div class="alert alert-success" role="alert" *ngIf="successMessage">
                    {{successMessage}}
                </div>
            </div>
            <!-- /.card-header -->
            <div class="card card-solid">
                <div class="card-body">
                <!---TAB START--->
                    <!-- Nav Tabs -->
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <button class="nav-link"
                                    [ngClass]="{'active': activeTab === 'home'}"
                                    (click)="selectTab('home')">
                                Details & Supplier Photos
                            </button>
                        </li>
                        <li class="nav-item">
                            <button class="nav-link"
                                    [ngClass]="{'active': activeTab === 'port-photos-video'}"
                                    (click)="selectTab('port-photos-video')">
                                Port Photos & Video
                            </button>
                        </li>
                        <li class="nav-item">
                            <button class="nav-link"
                                    [ngClass]="{'active': activeTab === 'documents'}"
                                    (click)="selectTab('documents')">
                                Documents
                            </button>
                        </li>
                        <li class="nav-item">
                            <button class="nav-link"
                                    [ngClass]="{'active': activeTab === 'duty-pmt-details'}"
                                    (click)="selectTab('duty-pmt-details')">
                                Duty Payment Details
                            </button>
                        </li>
                        <li class="nav-item">
                            <button class="nav-link"
                                    [ngClass]="{'active': activeTab === 'transfer-hist'}"
                                    (click)="selectTab('transfer-hist')">
                                Transfer History
                            </button>
                        </li>
                        <li class="nav-item">
                            <button class="nav-link"
                                    [ngClass]="{'active': activeTab === 'sale-offers'}"
                                    (click)="selectTab('sale-offers')">
                                Sale Offers
                            </button>
                        </li>
                    </ul>

                    <!-- Tab Content -->
                    <div class="tab-content mt-3">
                        <div class="tab-pane fade" [ngClass]="{'show active': activeTab === 'home'}">
                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div class="col-12">
                                        <div id="photoCarousel" class="carousel slide" data-ride="carousel">
                                            <ol class="carousel-indicators">
                                                <li *ngFor="let photo of photos; let i = index" [class.active]="i === 0" data-target="#photoCarousel" [attr.data-slide-to]="i"></li>
                                            </ol>

                                            <div class="carousel-inner">
                                                <div *ngFor="let photo of photos; let i = index" class="carousel-item" [class.active]="i === 0">
                                                    <div class="carousel-content-wrapper position-relative">
                                                        <img [src]="photo.image_url" class="d-block w-100" alt="Vehicle Photo" />
                                                    </div>
                                                </div>
                                            </div>

                                            <a class="carousel-control-prev" href="#photoCarousel" role="button" data-slide="prev">
                                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                <span class="sr-only">Previous</span>
                                            </a>
                                            <a class="carousel-control-next" href="#photoCarousel" role="button" data-slide="next">
                                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                <span class="sr-only">Next</span>
                                            </a>
                                        </div>
                                        &nbsp;
                                        <form (ngSubmit)="handleSubmit()">
                                            <ngx-dropzone (change)="onSelect($event)">
                                                <ngx-dropzone-label>Drag and drop files here or click to upload!</ngx-dropzone-label>
                                                <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files" [file]="f" [removable]="true" (removed)="onRemove(f)">
                                                    <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                                                </ngx-dropzone-image-preview>
                                            </ngx-dropzone>

                                            <div class="mt-4" >
                                                <button class="btn btn-success" type="button" *ngIf="isUploading; else showUploadBtn" disabled>
                                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                    Uploading...
                                                </button>

                                                <ng-template #showUploadBtn>
                                                    <button type="submit" class="btn btn-success"><i class="fas fa-upload fa-sm mr-2" aria-hidden="true">&nbsp;</i>Upload</button>
                                                </ng-template>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div style="float: right;" *ngIf="photos && photos.length > 0 && userPermissions.includes('del-vhcl-photos')">
                                        <a (click)="openDeletePhotosModal()" class="btn btn-success pull-left" class="btn btn-danger"><i
                                            class="fa fa-trash" aria-hidden="true">&nbsp;Delete Photos&nbsp;</i></a>
                                    </div>
                                    <h3 class="my-3">{{vehicle?.data?.make}} {{vehicle?.data?.model}}</h3>

                                    <div class="row clearfix">
                                        <div class="col-md-12">
                                            <div class="table-responsive">
                                                <table class="table">
                                                    <tbody>
                                                        <tr>
                                                            <td><b>Chassis No.:</b>&nbsp;{{vehicle.data.chassis_no}}</td>
                                                            <td><b>Engine CC:</b>&nbsp;{{vehicle.data.engine_cc}}</td>
                                                            <td><b>Engine No.:</b>&nbsp;{{vehicle.data.engine_no}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Transmission:</b>&nbsp;{{vehicle.data.transmission}}</td>
                                                            <td><b>Body Type:</b>&nbsp;{{vehicle.data.body_type}}</td>
                                                            <td><b>Drive:</b>&nbsp;{{vehicle.data.drive}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Fuel:</b>&nbsp;{{vehicle.data.fuel}}</td>
                                                            <td><b>Mileage:</b>&nbsp;{{vehicle.data.mileage}}</td>
                                                            <td><b>Colour:</b>&nbsp;{{vehicle.data.colour}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Year:</b>&nbsp;{{vehicle.data.year}}</td>
                                                            <td><b>Weight:</b>&nbsp;{{vehicle.data.weight}}</td>
                                                            <td><b>CBM:</b>&nbsp;{{vehicle.data.cbm}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Reg No.:</b>&nbsp;{{vehicle.data.reg_no}}</td>
                                                            <td><b>Status:</b>&nbsp;{{vehicle_status}}</td>
                                                            <td><b>Location:</b>&nbsp;{{vehicle.data.location}} - {{vehicle.data.branch}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-md-12">
                                            <h6><b>Available Spare Parts</b></h6>
                                            <div class="spare-parts-container">
                                                <div class="spare-parts-column" *ngFor="let column of spare_parts_columns">
                                                    <span *ngFor="let spare_part of column" class="spare-parts-item">
                                                        {{ spare_part.name }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div><!--/end row-->
                        </div>
                        <div class="tab-pane fade" [ngClass]="{'show active': activeTab === 'port-photos-video'}">
                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div class="col-12">
                                        <div id="portPhotoCarousel" class="carousel slide" data-ride="carousel">
                                            <ol class="carousel-indicators">
                                                <li *ngFor="let port_photo of port_photos; let i = index" [class.active]="i === 0" data-target="#portPhotoCarousel" [attr.data-slide-to]="i"></li>
                                            </ol>

                                            <div class="carousel-inner">
                                                <div *ngFor="let port_photo of port_photos; let i = index" class="carousel-item" [class.active]="i === 0">
                                                    <div class="carousel-content-wrapper position-relative">
                                                        <img [src]="port_photo.image_url" class="d-block w-100" alt="Vehicle Port Photo" />
                                                    </div>
                                                </div>
                                            </div>

                                            <a class="carousel-control-prev" href="#portPhotoCarousel" role="button" data-slide="prev">
                                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                <span class="sr-only">Previous</span>
                                            </a>
                                            <a class="carousel-control-next" href="#portPhotoCarousel" role="button" data-slide="next">
                                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                <span class="sr-only">Next</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="col-12">
                                        <video class="w-100" controls [attr.src]="video_url">
                                            Your browser does not support the video tag.
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" [ngClass]="{'show active': activeTab === 'documents'}">
                            <div class="row">
                                <div class="col-12 col-sm-12">
                                    <div style="float: right; padding-bottom: 20px;">
                                        <a (click)="openAddAttachmentModal()" class="btn btn-success pull-left" class="btn btn-success" *ngIf="userPermissions.includes('add-vhcl-atts')"><i
                                            class="fa fa-paperclip" aria-hidden="true">Add Document&nbsp;</i></a>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-12">
                                    <table id="example1" class="table table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th>Document Type</th>
                                            <th>Attached On</th>
                                            <th></th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let attachment of attachments">
                                            <td>{{attachment.doc_type}}</td>
                                            <td>{{attachment.attached_on| date: 'dd-MM-yyyy hh:mm a'}}</td>
                                            <td *ngIf="attachment.file_type==='image'"><a routerLink="/preview-vehicle-attachment/{{attachment.id}}/{{vehicle_id}}" class="btn btn-success" role="button" *ngIf="userPermissions.includes('view-vhcl-atts')"><i class="fa fa-eye" aria-hidden="true">&nbsp;</i>View</a></td>
                                            <td *ngIf="attachment.file_type==='pdf'">
                                                <a href="{{attachment.file_path}}" target="_blank" class="btn btn-success" role="button" *ngIf="userPermissions.includes('view-vhcl-atts')"> <i class="fa fa-eye" aria-hidden="true">&nbsp;</i>View</a>
                                            </td>
                                            <td *ngIf="attachment.updatable=='1'">
                                                <a (click)="openUpdateAttachmentModal(attachment.upload_type,attachment.upload_ref,attachment.file_path)" class="btn btn-success" role="button" *ngIf="userPermissions.includes('rplc-vhcl-atts')"> <i class="fa fa-upload" aria-hidden="true">&nbsp;</i>Replace</a>
                                            </td>
                                        </tr>
                                    </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" [ngClass]="{'show active': activeTab === 'duty-pmt-details'}">
                            <div class="row">
                                <div class="col-12 col-sm-6">
                                <div class="col-12">
                                    <div class="table-responsive">
                                        <table class="table">
                                            <tbody>
                                                <tr>
                                                    <td><b>Duty Paid Total:</b>&nbsp;{{vehicle.data.duty_paid| currency:'Kshs '}}</td>
                                                    <td><b>Port Charges:</b>&nbsp;{{vehicle.data.port_charges| currency:'Kshs '}}</td>
                                                    <td><b>Total Cost:</b>&nbsp;{{vehicle.data.total_cost| currency:'Kshs '}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="separator">Duty Payment Details</div>
                                    <table id="duty_details" class="table table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th>Doc Ref. No.</th>
                                                <th>Payment Ref. No.</th>
                                                <th>Amount Paid</th>
                                                <th>Payment Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let duty_payment of duty_payments">
                                                <td>{{duty_payment.doc_ref_no}}</td>
                                                <td>{{duty_payment.pmt_ref_no}}</td>
                                                <td>{{duty_payment.amount_paid| currency:'Kshs '}}</td>
                                                <td>{{duty_payment.pmt_date| date: 'dd-MM-yyyy'}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" [ngClass]="{'show active': activeTab === 'transfer-hist'}">
                            <div class="row">
                                <div class="col-12">
                                    <div class="card-body" style="overflow-x: auto; white-space: nowrap;">
                                        <!--Error Message-->
                                        <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
                                          {{errorMessage}}
                                        </div>
                                      <table id="example1" class="table table-bordered table-hover">
                                        <thead>
                                        <tr>
                                            <th>Make</th>
                                            <th>Model</th>
                                            <th>Chassis No.</th>
                                            <th>From Location</th>
                                            <th>To Location</th>
                                            <th>Transferred On</th>
                                            <th>Transferred By</th>
                                            <th>Transfer Reason</th>
                                            <th>Received At</th>
                                            <th>Received On</th>
                                            <th>Received By</th>
                                            <th>Duration</th>
                                            <th>Transfer Source</th>
                                            <th></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let vehicle of transfer_history | paginate: { itemsPerPage: 10, currentPage: page, totalItems: count }" [ngClass]="{'highlight-row': vehicle.part_flag === 1}">
                                              <td>{{vehicle.make}}</td>
                                              <td>{{vehicle.model}}</td>
                                              <td>{{vehicle.chassis_no}}</td>
                                              <td>
                                                <ng-container *ngIf="vehicle.from_location; else emptyFromLocation">
                                                  {{ vehicle.from_location }}
                                                </ng-container>
                                                <ng-template #emptyFromLocation>
                                                 CFS/Port
                                                </ng-template>
                                              </td>
                                              <td>
                                                <ng-container *ngIf="vehicle.to_location; else emptyToLocation">
                                                  {{ vehicle.to_location }}
                                                </ng-container>
                                                <ng-template #emptyToLocation>
                                                  Any Location/Branch
                                                </ng-template>
                                              </td>
                                              <td>{{vehicle.transferred_on | date: 'dd-MM-yyyy h:mm a'}}</td>
                                              <td>{{vehicle.transferred_by}}</td>
                                              <td>{{vehicle.transfer_reason}}</td>
                                              <td>{{vehicle.received_at}}</td>
                                              <td>{{vehicle.received_on | date: 'dd-MM-yyyy h:mm a'}}</td>
                                              <td>{{vehicle.received_by}}</td>
                                              <td>{{vehicle.transfer_duration}}</td>
                                              <td>{{vehicle.transfer_source}}</td>
                                              <td>
                                                <div class="dropdown">
                                                    <button class="btn btn-default dropdown-toggle" type="button"
                                                        data-toggle="dropdown"><i class="fas fa-eye"></i>&nbsp;View
                                                        <span class="caret"></span></button>
                                                    <ul class="dropdown-menu">
                                                        <li><a class="dropdown-item" target="_blank" routerLink="/view-transferred-vehicle/{{vehicle.transfer_log_id}}" *ngIf="vehicle.transfer_log_id!=null && vehicle.transfer_reason!='Delivery'"><i class="fas fa-angle-double-right"></i>&nbsp;Transfer Details</a></li>
                                                        <li><a class="dropdown-item" target="_blank" routerLink="/view-received-vehicle/{{vehicle.receive_log_id}}" *ngIf="vehicle.receive_log_id!=null && vehicle.transfer_reason!='Delivery'"><i class="fas fa-angle-double-left"></i>&nbsp;Receiving Details</a></li>
                                                        <li><a class="dropdown-item" target="_blank" routerLink="/view-transferred-vehicle/{{vehicle.transfer_log_id}}" *ngIf="vehicle.transfer_log_id!=null && vehicle.transfer_reason=='Delivery'"><i class="fas fa-angle-double-right"></i>&nbsp;Delivery Details</a></li>
                                                    </ul>
                                                </div>
                                              </td>
                                            </tr>
                                        </tbody>
                                      </table>
                                      <pagination-controls (pageChange)="pageChangeEvent($event)"></pagination-controls>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" [ngClass]="{'show active': activeTab === 'sale-offers'}">
                          <div class="row">
                            <div class="col-12">
                              <div class="card-body" style="overflow-x: auto; white-space: nowrap;">
                                  <div *ngIf="sale_offers.length === 0" class="text-center text-muted py-4">
                                      No sale offers for this vehicle yet!
                                  </div>
                                  <div class="d-flex flex-column gap-3" style="white-space: normal;">
                                    <div
                                      *ngFor="let offer of sale_offers"
                                      class="card shadow-sm offer-card"
                                      (click)="openOfferDetails(offer)"
                                      data-toggle="modal"
                                      data-target="#offerDetailsModal"
                                      role="button"
                                    >
                                      <div class="card-body">
                                        <!-- Name + deal type badge -->
                                        <div class="d-flex justify-content-between align-items-start">
                                          <h6 class="mb-0 font-weight-bold">{{ offer.customer_name }}</h6>
                                          <span class="badge" [ngClass]="isCashDeal(offer) ? 'badge-success' : 'badge-primary'">
                                            {{ offer.deal_type }}
                                          </span>
                                        </div>

                                        <div class="d-flex justify-content-between align-items-center mt-1">
                                          <small class="text-muted">{{ offer.customer_phone_no }}</small>
                                          <span *ngIf="hasBroker(offer)" class="badge badge-warning ml-2">Broker Involved</span>
                                        </div>

                                        <hr class="my-2">

                                        <!-- Summary line: differs by deal type -->
                                        <div class="row text-center" *ngIf="isCashDeal(offer)">
                                          <div class="col-5 text-left">
                                            <small class="text-muted d-block">Sales Rep Offer</small>
                                            <strong>{{ formatCurrency(offer.sales_rep_cash_price_offer) }}</strong>
                                          </div>
                                          <div class="col-2 d-flex align-items-center justify-content-center">
                                            <i class="fas fa-arrow-right text-muted"></i>
                                          </div>
                                          <div class="col-5 text-right">
                                            <small class="text-muted d-block">Customer Offer</small>
                                            <strong [ngClass]="(+offer.cust_cash_price_offer < +offer.sales_rep_cash_price_offer) ? 'text-danger' : 'text-success'">
                                              {{ formatCurrency(offer.cust_cash_price_offer) }}
                                            </strong>
                                          </div>
                                        </div>

                                        <div class="row text-center" *ngIf="!isCashDeal(offer)">
                                          <div class="col-5 text-left">
                                            <small class="text-muted d-block">Rep Total Price</small>
                                            <strong>{{ formatCurrency(offer.sales_rep_hp_price_offer) }}</strong>
                                          </div>
                                          <div class="col-2 d-flex align-items-center justify-content-center">
                                            <i class="fas fa-arrow-right text-muted"></i>
                                          </div>
                                          <div class="col-5 text-right">
                                            <small class="text-muted d-block">Customer Total Price</small>
                                            <strong [ngClass]="(+offer.cust_hp_price_offer < +offer.sales_rep_hp_price_offer) ? 'text-danger' : 'text-success'">
                                              {{ formatCurrency(offer.cust_hp_price_offer) }}
                                            </strong>
                                          </div>
                                        </div>

                                        <div *ngIf="offer.remarks" class="bg-light rounded p-2 mt-2">
                                          <small class="font-italic">{{ offer.remarks }}</small>
                                        </div>

                                        <div class="d-flex justify-content-between align-items-center mt-2">
                                          <small class="text-muted"><i class="fas fa-user"></i> {{ offer.sales_rep_name }}</small>
                                          <small class="text-muted">{{ formatDate(offer.posted_on) }} <i class="fas fa-chevron-right"></i></small>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                <!---TAB END--->
                </div>
                <!-- /.card-body -->
            </div>
            <!-- /.card-body -->
        </div>
    </div>
</section>

<!--Delete photos modal-->
<div class="modal fade" #DeletePhotosModal tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Delete Photos</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <!--Error message-->
            <div class="alert alert-danger" role="alert" *ngIf="delPhotosPopupErrorMessage">
                {{delPhotosPopupErrorMessage}}
            </div>
            <table class="table" *ngFor="let photo of photos">
                <td>
                    <img src="{{photo.image_url}}" height="70" width="120"/>
                </td>
                <td>
                    <input type="checkbox" class="form-control" [(ngModel)]="photo.checked" (change)="checkboxChange($event, photo.image_url)" id="vehicle" name="photo">
                </td>
            </table>
            <div class="d-flex justify-content-end mr-4 mb-3">
                <div class="btn btn-danger btn-sm btn-flat" (click)="deletePhotos()">
                    <i class="fas fa-trash fa-sm mr-2"></i>
                    Delete
                </div>
            </div>
        </div>
    </div>
</div>

<!--Update attachment modal-->
<div class="modal fade" #UpdateVehicleAttachmentsModal tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Replace Vehicle Document</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <!--Error message-->
            <div class="alert alert-danger" role="alert" *ngIf="popupErrorMessage">
                {{popupErrorMessage}}
            </div>
            <!--Success message-->
            <div class="alert alert-success" role="alert" *ngIf="popupSuccessMessage">
                {{popupSuccessMessage}}
            </div>

             <!--Warning message-->
            <div class="alert alert-warning" role="alert" *ngIf="popupWarningMessage">
                {{popupWarningMessage}}
            </div>

            <form [formGroup]="form" (ngSubmit)="updateAttachment()">
                <div class="modal-body">
                    <div class="container-fluid">
                        <div class="form-group">
                            <label>Attachment (Image or PDF):<span style="color:red;">*</span></label>
                            <div class="input-group mb-3">
                                <div class="custom-file">
                                <input type="file" formControlName="attachment" accept="application/pdf,image/*" class="custom-file-input" id="inputGroupFile01" aria-describedby="inputGroupFileAddon01" (change)="onReplacementAttachmentSelected($event)">
                                <label class="custom-file-label" for="inputGroupFile01">{{ replacementFileName }}</label>
                                </div>
                            </div>

                            <span *ngIf="submitted && form.get('attachment')?.hasError('required')" style="color:red"> <strong>Please choose a file to upload!</strong></span>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" #closeModal class="btn btn-danger" data-dismiss="modal"><i class="fa fa-window-close" aria-hidden="true"></i>&nbsp;Cancel</button>

                    <button class="btn btn-success" type="button" *ngIf="isProcessing; else showSaveBtn" disabled>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Processing...
                    </button>

                    <ng-template #showSaveBtn>
                        <button type="submit" class="btn btn-success" ><i class="fa fa-upload"
                            aria-hidden="true">&nbsp;</i>Upload</button>
                    </ng-template>
                </div>
            </form>
        </div>
    </div>
</div>

<!--Add attachment modal-->
<div class="modal fade" #AddAttachmentModal tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Add Document</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

         <!--Error message-->
        <div class="alert alert-danger" role="alert" *ngIf="newAttPopupErrorMessage">
            {{newAttPopupErrorMessage}}
        </div>
        <!--Success message-->
        <div class="alert alert-success" role="alert" *ngIf="newAttPopupSuccessMessage">
            {{newAttPopupSuccessMessage}}
        </div>

         <!--Warning message-->
        <div class="alert alert-warning" role="alert" *ngIf="newAttPopupWarningMessage">
            {{newAttPopupWarningMessage}}
        </div>

        <form [formGroup]="addAttachmentForm" (ngSubmit)="uploadNewAttachment()">
          <div class="modal-body">
            <div class="form-group">
                <label>Document Type:<span style="color:red;">*</span></label>
                <select formControlName="doc_type" class="form-control" (change)="onSelectChange($event.target)">
                    <option value="">Select</option>
                    <option value="Jevic">Jevic</option>
                    <option value="Japan LogBook">Japan LogBook</option>
                    <option value="Japan LogBook Translation">Japan LogBook Translation</option>
                    <option value="Other Import Document">Other Import Document</option>
                    <option value="Other">Other</option>
                </select>

                <span *ngIf="submitted && addAttachmentForm.get('doc_type')?.hasError('required')" style="color:red"><strong>Please select document type!</strong></span>
            </div>
            <div class="form-group" *ngIf="docNameIsRequired">
                <label>Document Name:<span style="color:red;">*</span></label>
                <input type="text" formControlName="doc_name" class="form-control"  value="" placeholder="Enter the best description of the document">
            </div>
            <div class="form-group">
                <label>Attachment (Image or PDF):<span style="color:red;">*</span></label>
                <div class="input-group mb-3">
                    <div class="custom-file">
                        <input type="file" formControlName="new_attachment" accept="application/pdf,image/*" class="custom-file-input" id="new_attachment" aria-describedby="inputGroupFileAddon01" (change)="onNewAttachmentSelected($event)">
                        <label class="custom-file-label" for="inputGroupFile01">{{ newAttachmentFileName }}</label>
                    </div>
                </div>

                <span *ngIf="submitted && addAttachmentForm.get('new_attachment')?.hasError('required')" style="color:red"> <strong>Please choose a file to upload!</strong></span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button class="btn btn-success" type="button" *ngIf="isProcessing; else showUploadBtn" disabled>
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Processing...
            </button>

            <ng-template #showUploadBtn>
                <button type="submit" class="btn btn-success"><i class="fa fa-save" aria-hidden="true">&nbsp;</i>Upload</button>
            </ng-template>
          </div>
        </form>
      </div>
    </div>
</div>

<!-- Details modal, rendered once, populated from selectedOffer -->
<div class="modal fade" id="offerDetailsModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" *ngIf="selectedOffer as offer">
      <div class="modal-header">
        <div>
          <h5 class="modal-title mb-0">{{ offer.customer_name }}</h5>
          <small class="text-muted">{{ offer.customer_phone_no }}</small>
        </div>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">

        <ng-container *ngIf="isCashDeal(offer); else hpDetails">
          <h6 class="text-uppercase text-muted small font-weight-bold">Cash Offer</h6>
          <div class="d-flex justify-content-between py-1">
            <span class="text-muted">Sales Rep's Offer</span>
            <strong>{{ formatCurrency(offer.sales_rep_cash_price_offer) }}</strong>
          </div>
          <div class="d-flex justify-content-between py-1">
            <span class="text-muted">Customer's Offer</span>
            <strong>{{ formatCurrency(offer.cust_cash_price_offer) }}</strong>
          </div>
        </ng-container>

        <ng-template #hpDetails>
          <h6 class="text-uppercase text-muted small font-weight-bold">Sales Rep's Hire Purchase Offer</h6>
          <div class="d-flex justify-content-between py-1">
            <span class="text-muted">Total Price</span>
            <strong>{{ formatCurrency(offer.sales_rep_hp_price_offer) }}</strong>
          </div>
          <div class="d-flex justify-content-between py-1">
            <span class="text-muted">Deposit</span>
            <strong>{{ formatCurrency(offer.sales_rep_hp_deposit_offer) }}</strong>
          </div>
          <div class="d-flex justify-content-between py-1">
            <span class="text-muted">No. of Instalments</span>
            <strong>{{ offer.sales_rep_hp_no_of_inst_offer | number:'1.0-0' }}</strong>
          </div>

          <h6 class="text-uppercase text-muted small font-weight-bold mt-3">Customer's Hire Purchase Offer</h6>
          <div class="d-flex justify-content-between py-1">
            <span class="text-muted">Total Price</span>
            <strong>{{ formatCurrency(offer.cust_hp_price_offer) }}</strong>
          </div>
          <div class="d-flex justify-content-between py-1">
            <span class="text-muted">Deposit</span>
            <strong>{{ formatCurrency(offer.cust_hp_deposit_offer) }}</strong>
          </div>
          <div class="d-flex justify-content-between py-1">
            <span class="text-muted">No. of Instalments</span>
            <strong>{{ offer.cust_hp_no_of_inst_offer | number:'1.0-0' }}</strong>
          </div>
        </ng-template>

        <ng-container *ngIf="hasBroker(offer)">
          <h6 class="text-uppercase text-muted small font-weight-bold mt-3">Broker</h6>
          <div class="d-flex justify-content-between py-1">
            <span class="text-muted">Name</span>
            <strong>{{ offer.broker_name }}</strong>
          </div>
          <div class="d-flex justify-content-between py-1">
            <span class="text-muted">Phone No.</span>
            <strong>{{ offer.broker_phone_no }}</strong>
          </div>
          <div class="d-flex justify-content-between py-1">
            <span class="text-muted">Commission</span>
            <strong>{{ formatCurrency(offer.broker_comm) }}</strong>
          </div>
        </ng-container>

        <ng-container *ngIf="offer.remarks">
          <h6 class="text-uppercase text-muted small font-weight-bold mt-3">Remarks</h6>
          <p class="mb-0">{{ offer.remarks }}</p>
        </ng-container>

        <hr>
        <div class="d-flex justify-content-between py-1">
          <span class="text-muted">Sales Rep</span>
          <span>{{ offer.sales_rep_name }}</span>
        </div>
        <div class="d-flex justify-content-between py-1">
          <span class="text-muted">Branch</span>
          <span>{{ offer.location_name }} - {{ offer.branch_name }}</span>
        </div>
        <div class="d-flex justify-content-between py-1">
          <span class="text-muted">Posted On</span>
          <span>{{ formatDate(offer.posted_on) }}</span>
        </div>

        <button
        type="button"
        class="btn btn-outline-success btn-block mt-3"
        data-dismiss="modal"
        (click)="openFollowUps(offer.id)"
      >
        <i class="fas fa-history mr-1"></i>
        View Follow-ups
      </button>
      </div>
    </div>
  </div>
</div>


<!-- Sale Offer Follow-ups Modal -->
<div class="modal fade" #SaleOfferFollowUpsModal tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-history mr-1"></i>
          Sale Offer Follow-ups
        </h5>

        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">

        <!-- Loading -->
        <div *ngIf="isLoading" class="text-center py-4">
          <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
          <p class="text-muted mt-2 mb-0">Loading follow-ups...</p>
        </div>

        <!-- Empty state -->
        <div
          *ngIf="!isLoading && sale_offer_follow_ups.length === 0"
          class="text-center text-muted py-4"
        >
          <i class="fas fa-inbox fa-2x mb-2"></i>
          <p class="mb-0">
            No follow-ups available for this sale offer.
          </p>
        </div>

        <!-- Follow-up cards -->
        <div
          *ngIf="!isLoading && sale_offer_follow_ups.length > 0"
          class="d-flex flex-column"
          style="gap: 15px;"
        >
          <div
            *ngFor="let followUp of sale_offer_follow_ups"
            class="card shadow-sm mb-0"
          >
            <div class="card-body">

              <!-- Deal type and follow-up date -->
              <div class="d-flex justify-content-between align-items-start">
                <h6 class="font-weight-bold mb-0">
                  {{ followUp.deal_type }}
                </h6>

                <span class="badge badge-light">
                  {{ followUp.follow_up_date
                      ? formatDate(followUp.follow_up_date)
                      : 'No follow-up date' }}
                </span>
              </div>

              <hr class="my-2">

              <!-- Cash offer -->
              <ng-container *ngIf="followUp.deal_type === 'Cash'; else hpFollowUp">

                <div class="d-flex justify-content-between py-1">
                  <span class="text-muted">Sales Rep's Offer</span>
                  <strong>
                    {{ formatCurrency(followUp.sales_rep_cash_price_offer) }}
                  </strong>
                </div>

                <div class="d-flex justify-content-between py-1">
                  <span class="text-muted">Customer's Offer</span>
                  <strong>
                    {{ formatCurrency(followUp.cust_cash_price_offer) }}
                  </strong>
                </div>

              </ng-container>

              <!-- Hire Purchase offer -->
              <ng-template #hpFollowUp>

                <div class="d-flex justify-content-between py-1">
                  <span class="text-muted">Sales Rep's Total Price</span>
                  <strong>
                    {{ formatCurrency(followUp.sales_rep_hp_price_offer) }}
                  </strong>
                </div>

                <div class="d-flex justify-content-between py-1">
                  <span class="text-muted">Sales Rep's Deposit</span>
                  <strong>
                    {{ formatCurrency(followUp.sales_rep_hp_deposit_offer) }}
                  </strong>
                </div>

                <div class="d-flex justify-content-between py-1">
                  <span class="text-muted">Sales Rep's Instalments</span>
                  <strong>
                    {{ followUp.sales_rep_hp_no_of_inst_offer
                        | number:'1.0-0' }}
                  </strong>
                </div>

                <hr class="my-2">

                <div class="d-flex justify-content-between py-1">
                  <span class="text-muted">Customer's Total Price</span>
                  <strong>
                    {{ formatCurrency(followUp.cust_hp_price_offer) }}
                  </strong>
                </div>

                <div class="d-flex justify-content-between py-1">
                  <span class="text-muted">Customer's Deposit</span>
                  <strong>
                    {{ formatCurrency(followUp.cust_hp_deposit_offer) }}
                  </strong>
                </div>

                <div class="d-flex justify-content-between py-1">
                  <span class="text-muted">Customer's Instalments</span>
                  <strong>
                    {{ followUp.cust_hp_no_of_inst_offer
                        | number:'1.0-0' }}
                  </strong>
                </div>

              </ng-template>

              <!-- Broker -->
              <div
                *ngIf="followUp.deal_has_broker === 'Yes'"
                class="d-flex justify-content-between py-1 mt-2"
              >
                <span class="text-muted">Broker Commission</span>
                <strong>
                  {{ formatCurrency(followUp.broker_comm) }}
                </strong>
              </div>

              <!-- Notes -->
              <div
                *ngIf="followUp.notes"
                class="bg-light rounded p-2 mt-2"
              >
                <small class="text-muted d-block mb-1">Notes</small>
                <span>{{ followUp.notes }}</span>
              </div>

              <!-- Posted date -->
              <div class="text-right mt-2">
                <small class="text-muted">
                  Posted On: {{ formatDate(followUp.posted_on) }}
                </small>
              </div>

            </div>
          </div>
        </div>

      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
        >
          Close
        </button>
      </div>

    </div>
  </div>
</div>
